/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	InternshipEnrollmentDTO,
	InternshipEnrollmentDTOFromJSON,
	InternshipEnrollmentDTOFromJSONTyped,
	InternshipEnrollmentDTOToJSON,
} from "./InternshipEnrollmentDTO";

/**
 *
 * @export
 * @interface InternshipEnrollmentDTOPagedResponse
 */
export interface InternshipEnrollmentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof InternshipEnrollmentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternshipEnrollmentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternshipEnrollmentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<InternshipEnrollmentDTO>}
	 * @memberof InternshipEnrollmentDTOPagedResponse
	 */
	data?: Array<InternshipEnrollmentDTO> | null;
}

export function InternshipEnrollmentDTOPagedResponseFromJSON(
	json: any
): InternshipEnrollmentDTOPagedResponse {
	return InternshipEnrollmentDTOPagedResponseFromJSONTyped(json, false);
}

export function InternshipEnrollmentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InternshipEnrollmentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(InternshipEnrollmentDTOFromJSON),
	};
}

export function InternshipEnrollmentDTOPagedResponseToJSON(
	value?: InternshipEnrollmentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(InternshipEnrollmentDTOToJSON),
	};
}
